import * as yup from "yup";

const stringDates = () => {
  let dates: string[] = [];
  for (let i = 1; i <= 31; i++) {
    dates.push(i.toString());
  }
  return dates;
}

const exceptionsSchema = yup.object().shape({
  closureType: yup.string().typeError('Este campo não aceita número')
  .required("Este campo é obrigatório")
  .notOneOf(["-"], "É necessário selecionar alguma das opções disponíveis para continuar"),
  closingDay: yup.string().oneOf(stringDates(), 'Deve estar entre 1 e 31'),
  retailChainId: yup.string().typeError('Este campo não aceita número')
  .required("Este campo é obrigatório")
  .notOneOf(["-"], "É necessário selecionar alguma das opções disponíveis para continuar."),
});
  
const schema = yup.object().shape({
  closingDay: yup.string().oneOf(stringDates(), 'Deve estar entre 1 e 31'),
  closureType: yup.string().typeError('Este campo não aceita número')
  .required("Este campo é obrigatório")
  .notOneOf(["-"], "É necessário selecionar alguma das opções disponíveis para continuar."),
  exceptions: yup.array().of(exceptionsSchema),
});

export default schema;